import React from 'react';
import { site_base } from '../Site';
import {Col, Container, Row } from 'reactstrap';
import { T } from '../traks';

function Contact(props) {
	let extra_lawheader = null;
	let extra_header = null;
	let registry_txt = null;
	let content_section = null;
	let contact_h1 = <h1 className="pb-4"><T>Contact us</T></h1>;
	const vat_no = "DK 38962256";

	if(IS_INVESTSPIEL_DE) {
		contact_h1 = <h1 className="pb-4"><b><T>Imprint</T></b></h1>;
		extra_lawheader = <h4><T>Information according to &sect;5 German Teleservices Act</T></h4>;
		extra_header = <h4 className="pt-2"><T>Contact information</T></h4>;
		content_section = (
			<React.Fragment>
				<h4><T>Responsible for content</T></h4>
				<div>
					Mads Martin Jørgensen
				</div>
			</React.Fragment>
		);
		registry_txt = (
			<React.Fragment>
				<h4><T>Registry</T></h4>
				<div className="pb-4">
					<T>Commercial registries: Central Business Register Denmark</T><br />
					<T>Registration number:</T> {vat_no}
				</div>
			</React.Fragment>
		);
	}

	return (
		<Container>
			<Row className="ad_game_card bg-white pt-3 pb-5">
				<Col className="pt-3">
					{contact_h1}
					{extra_lawheader}
					<div className="pb-3">
						Aktiedysten ApS<br/>
						Flakhaven 1, 1.<br/>
						DK-5000 Odense C<br/>
						<T>Denmark</T><br/>
					</div>
					{extra_header}
					<div className="pb-4">
						Email: info@{site_base}<br/>
						<T>Phone</T>: +45 2877 0933<br/>
					</div>
					<h4><T>Managing director</T></h4>
					<div className="pb-4">
						Mads Martin Jørgensen
					</div>
					{registry_txt}
					<h4><T>VAT information</T></h4>
					<div className="pb-4">
						<T>VAT ID</T>: {vat_no}
					</div>
					{content_section}
				</Col>
			</Row>
		</Container>
	);
}
export default Contact;



// WEBPACK FOOTER //
// ./src/p/Contact.js